import { DataTable } from "carbon-components-react";
import React from "react";
import { useSelector } from "react-redux";
import DeleteDonationsModal from "./DeleteDonationsModal";
import UpdateDonationsModal from "./UpdateDonationsModal";
import { LoadingIndicator } from "../../components";
import { getDonationsData, getDonationsIsFetching } from "../../selectors";

const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
} = DataTable;

const headers = [
  {
    header: "First Name",
    key: "first_name",
  },
  {
    header: "Last Name",
    key: "last_name",
  },
  {
    header: "Email",
    key: "email_address",
  },
  {
    header: "Date",
    key: "donation_data",
  },
  {
    header: "Amount",
    key: "donation_amount",
  },
  {
    header: "Selected Team",
    key: "selected_team",
  },
  {
    header: "Beneficiary",
    key: "selected_beneficiary",
  },
  {
    header: "Comment",
    key: "comment",
  },
  {
    header: "Account Number",
    key: "account_number",
  },
  {
    header: "Address",
    key: "input_address",
  },
  {
    header: "City",
    key: "input_city",
  },
  {
    header: "State",
    key: "input_state",
  },
  {
    header: "Zip",
    key: "input_zip",
  },
];

const DonationsTable = () => {
  const donationsDataIsFetching = useSelector(getDonationsIsFetching);
  const donationsData = useSelector(getDonationsData);

  donationsData.sort((a, b) => {
    return b.donation_amount - a.donation_amount;
  });

  donationsData.forEach((element) => {
    element.donation_data = new Date(element.donation_data).toString();
  });

  return (
    <div style={{ backgroundColor: "#e0e0e0" }}>
      <LoadingIndicator active={donationsDataIsFetching} />
      <DataTable
        rows={donationsData}
        headers={headers}
        isSortable={true}
        render={({ rows, headers, getHeaderProps }) => (
          <TableContainer title="Donations">
            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader
                      key={header.key}
                      {...getHeaderProps({ header })}
                    >
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                    <TableCell>
                      <DeleteDonationsModal donation={row} />
                    </TableCell>
                    <TableCell>
                      <UpdateDonationsModal donation={row} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />
    </div>
  );
};

export default DonationsTable;
